import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import classes2 from './EditIndents.module.css'
import axios from '../../../Axios';
import { Urls } from '../../../Urls';
import { toast } from 'react-toastify'
import mixpanel from 'mixpanel-browser'
import { currentRequestTimeStamp } from '../../../Constants';
import { mailerAPI } from '../../Freightrates1/Utility';
import { checkModuleAccess } from '../../../Utility';
import { useIndentTracking } from '../hooks/useIndentTracking';

const EditIndents = ({ item, index, truck_types, todaydate, getIndents, emailTemplate }) => {
    const [editableDetails, seteditableDetails] = useState({})
    const [trucks, settrucks] = useState([])
    const [dateofplacement, setdateofplacement] = useState()
    // const [show, setshow] = useState(false)
    var user_name = localStorage.getItem('userdetails');

    const { trackIndentEvent } = useIndentTracking()

    useEffect(() => {
        // Extract the placement date from item.indent_info
        var mindate = item.indent_info.placement_date;

        // Split the placement date into day, month, and year
        var day = mindate.split("-")[0];
        var month = mindate.split("-")[1];
        var year = mindate.split("-")[2];

        // Reformat the placement date to 'YYYY-MM-DD'
        var currentdate = year + '-' + month + "-" + day;

        // Update the state with the reformatted placement date
        setdateofplacement(currentdate);

        // Copy the indent info and update shortlisted transporters
        var temp = item.indent_info ? item.indent_info : [];
        temp.shortlisted_transporters.map((item) => {
            item.is_shortlist = true;
            return item;
        });

        // Update state with the modified indent info
        seteditableDetails(temp);

        // Update state with truck types
        settrucks(item.indent_info.truck_types);

        // Track the edit indent button click event using Mixpanel
        trackIndentEvent("indent request", "user has clicked on edit indent button", `display indent id: ${item.display_indent_id}` )

    }, []);


    const handleChange = (e, name) => {

        // Check if the field being updated is 'truck_types'
        if (name === 'truck_types') {
            // Initialize a new list and add the value from the event
            var list = [];
            list.push(e);

            // Create a temporary copy of the editableDetails object
            var temp = editableDetails;

            // Update the 'truck_types' field with the new list
            temp[name] = list;

            // Update the state with the modified details
            seteditableDetails(temp);

            // Update the trucks state with the new list
            settrucks(list);
        }
        else {
            // For other fields, simply update the field with the event value
            temp = editableDetails;
            temp[name] = e;

            // Update the state with the modified details
            seteditableDetails(temp);
        }
    }

    /**
     *  * Handles the submission of the edited indent details.
     * This function performs the following tasks:
     * 1. Validates the form input to ensure that placement date and truck required fields are not empty, negative, or zero.
     * 2. If validation passes, it updates the indent information with the edited details.
     * 3. Sends an API request to update the indent on the server.
     * 4. Sends an email notification to the company with the updated indent details.
     * 5. Sends email notifications to shortlisted transporters with updated indent details.
     * 6. Sends SMS notifications to transporters if contact numbers are available (commented out).
     * 7. Reloads the indents list and closes the edit modal.
     * @param {Event} e - The event object associated with the submit action.
     * @returns {void}
     */
    const submitHandler = (e) => {
        // Check if required fields are empty or invalid
        var temp = parseInt(editableDetails.truck_required);
        if (editableDetails.placement_date === '' ||
            editableDetails.truck_required === '' ||
            editableDetails.truck_required === 0 ||
            editableDetails.truck_required === '0' ||
            temp <= 0
        ) {
            toast.error("Values cannot be empty or negative");
        } else {
            // Prepare the edited indent object
            var edited_indents = item;
            edited_indents.indent_info = editableDetails;

            trackIndentEvent(
                "indent request",
                "user has submitted edited indent details",
                `display indent id: ${item?.display_indent_id || "NA"}, old indent info: ${
                    JSON.stringify(item?.indent_info || {}, null, 2)
            }`
            );


            // API call to submit edited indent details
            axios.put(`${Urls.indent}?indent_id=${item.indent_id}&field=edit_indent`, {
                edited_indents
            })
                .then(res => {
                    // Show success message and close modal
                    toast.success("Indent Edited successfully");
                    document.getElementById('close_contactus').click();
                    var company_name = localStorage.getItem('companyname')
                    // Prepare email content for the company
                    var company_mail = localStorage.getItem('useremail');
                    var indent_id = item.display_indent_id;
                    // var company_list = company_mail.split("@")
                    // var company = company_list[1].split('.')[0]
                    var indent_table = `<table border="1">
                                    <thead>
                                        <th>Indent ID</th>
                                        <th>Edited On</th>
                                        <th>Origin</th>
                                        <th>Destination</th>
                                        <th>Truck Type</th>
                                        <th>#Trucks Required</th>
                                        <th>Date of Placement/Contract</th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>${item.display_indent_id}</td>
                                            <td>${todaydate}</td>
                                            <td>${item.indent_info.origin.location_name}</td>
                                            <td>${item.indent_info.destination.location_name}</td>
                                            <td>${item.indent_info.truck_types[0].value}</td>
                                            <td>${item.indent_info.truck_required}</td>
                                            <td>${item.indent_info.placement_date}</td>
                                        </tr>
                                    </tbody>
                                </table>`;
                    var emailBody = {
                        'activity': 'Email Request',
                        'type': 'superlaunch',
                        'mail_status': 'Pending',
                        'from_email': emailTemplate.updateFromCompany === "user" ? localStorage.getItem("useremail") : "connect@logisticsnow.in",
                        'user_type': 'company',
                        'cc': emailTemplate.updateCCCompany && emailTemplate.updateCCCompany !== "" ? 'connect@logisticsnow.in' : 'connect@logisticsnow.in',
                        'subject': eval('`' + emailTemplate.updateSubjectCompany + '`'),
                        'content': eval('`' + emailTemplate.updateContentCompany + '`'),
                        'to_email': `${company_mail}`,
                        'Application_name': 'lorri',
                        'module_name': 'Indents',
                        'timestamp': currentRequestTimeStamp(),
                    };
                    // mailerAPI(emailBody);

                    // Notify shortlisted transporters
                    if (item) {
                        var list = [];
                        item.indent_info.shortlisted_transporters.map((transporter) => {
                            if ((transporter.is_shortlist && transporter.contact_information && transporter.contact_information.length > 0) || (transporter.is_shortlist && transporter.access_control && transporter.access_control.length > 0)) {
                                if (!list.includes(transporter.transporter_id)) {
                                    transporter.contact_information.map((poc) => {
                                        if (checkModuleAccess(transporter.access_control, poc.contact_number, 'Indent', item.company_name)) {
                                            var localtable = `<table border="1">
                                    <thead>
                                        <th>Indent Request Number</th>
                                        <th>Date of Indent</th>
                                        <th>Origin</th>
                                        <th>Destination</th>
                                        <th>Truck Type</th>
                                        <th>#Trucks Required</th>
                                        <th>Date of Placement</th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>${item.display_indent_id}</td>
                                            <td>${item.created_date}</td>
                                            <td>${item.indent_info.origin.location_name}</td>
                                            <td>${item.indent_info.destination.location_name}</td>
                                            <td>${Array.isArray(item.indent_info.truck_types) ? item.indent_info.truck_types.map((ttt) => {
                                                return ttt.value
                                            }) : item.indent_info.truck_types.label}</td>
                                            <td>${item.indent_info.truck_required ? item.indent_info.truck_required : 'NA'}</td>
                                            <td>${item.indent_info.placement_date ? item.indent_info.placement_date : 'NA'}</td>
                                        </tr>
                                    </tbody>
                                            </table>`
                                            var poc_name = poc.name;
                                            var indent_id = item.display_indent_id;
                                            var company_name = item.company_name
                                            // console.log(eval('`'+localtable+'`'))
                                            var emailTransporterBody = {
                                                'activity': 'Email Request',
                                                'Application_name': 'lorri',
                                                'module_name': 'new enquiry',
                                                'timestamp': currentRequestTimeStamp(),
                                                'type': 'superlaunch',
                                                'mail_status': 'Pending',
                                                'from_email': emailTemplate.updateFromTransporter === "user" ? localStorage.getItem("useremail") : "lorri@logisticsnow.com",
                                                'user_type': "transporter",
                                                'cc': emailTemplate.updateCCTransporter && emailTemplate.updateCCTransporter !== "" ? 'lorri@logisticsnow.in' : 'lorri@logisticsnow.in',
                                                'subject': eval('`' + emailTemplate.updateSubjectTransporter + '`'),
                                                'content': eval('`' + emailTemplate.updateContentTransporter + '`'),
                                                'to_email': `${poc.email}`,
                                            }
                                            // console.log(emailTransporterBody.content)
                                            // mailerAPI(emailTransporterBody)
                                            if (poc.contact_number && poc.contact_number !== null & poc.contact_number !== undefined) {
                                                var contact = poc.contact_number.split('+91');
                                                if (contact[0] === '') {
                                                    // var smsTransporterBody = {
                                                    //     "activity" : "message_request",
                                                    //     "type" : "fast2sms",
                                                    //     "message" : `Updated Indent received from ${company_name}. Login to transporter.lorri.in to accept or reject indent.`,
                                                    //     "contact_number" : `${contact[1]}`,
                                                    //     "message_status" : "Pending",
                                                    //     "user_id" : localStorage.getItem('oid'),
                                                    //     "timestamp": currentRequestTimeStamp(),
                                                    // }
                                                    // console.log(smsTransporterBody)
                                                    // mailerAPI(smsTransporterBody, setshow)
                                                } else {
                                                    // var smsTransporterBody = {
                                                    //     "activity" : "message_request",
                                                    //     "type" : "fast2sms",
                                                    //      "message" : `Updated Indent received from ${company_name}. Login to transporter.lorri.in to accept or reject indent.`,
                                                    //     "contact_number" : `${contact[0]}`,
                                                    //     "message_status" : "Pending",
                                                    //     "user_id" :localStorage.getItem('oid'),
                                                    //     "timestamp": currentRequestTimeStamp(),
                                                    // }
                                                    // mailerAPI(smsTransporterBody, setshow)
                                                }
                                            }
                                            list.push(transporter.transporter_id);
                                        }
                                    });
                                }
                            }
                        });
                    }

                    // Reload the indents list
                    getIndents();
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
    return (
        <div>
            <div style={{ padding: '2%' }} className='row'>
                <div style={{ width: "98%" }} className={classes2['edit-container']}>
                    <div className={classes2['s-tt']}>
                        <center>
                            <span style={{ fontWeight: 'unset', fontSize: '14px' }}><b>Origin</b></span><br />

                        </center>
                        <span >
                            <input style={{ height: "38px" }}
                                disabled
                                type="text"
                                defaultValue={editableDetails.origin ? editableDetails.origin.location_name : ''}
                            />
                        </span>
                    </div>
                    <div className={classes2['s-tt']}>
                        <center>
                            <span style={{ fontWeight: 'unset', fontSize: '14px' }}><b>Destination</b></span><br />
                        </center>
                        <span >
                            <input style={{ height: "38px" }}
                                type="text"
                                defaultValue={editableDetails.destination ? editableDetails.destination.location_name : ''}
                                disabled
                            />
                        </span>
                    </div>
                </div>
                <div className={classes2['edit-container']}>
                    <div className={classes2['s-tt']}>
                        <center>
                            <span style={{ fontWeight: 'unset', fontSize: '14px' }}><b>Truck Type</b></span><br />
                        </center>
                        <span >
                            <Select
                                options={truck_types}
                                onChange={value => handleChange(value, 'truck_types')}
                                value={trucks}
                                className={"Truck_type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                formatCreateLabel={() => ''}
                                isDisabled={true}
                            />
                        </span>
                    </div>
                    <div className={classes2['s-tt-trucks']}>
                        <center>
                            <span style={{ fontWeight: 'unset', fontSize: '14px' }}><b># Trucks</b></span><br />
                        </center>
                        <span >
                            <input
                                //  style={{ height: "59px", textAlign: 'center' }} 
                                type="number"
                                placeholder="number of trucks"
                                min='1'
                                defaultValue={editableDetails.truck_required ? editableDetails.truck_required : ''}
                                onChange={e => handleChange(e.target.value, "truck_required")}
                                className={`${classes2['input_box']} origin`}
                                disabled
                            />
                        </span>
                    </div>
                    <div className={classes2['s-tt']}>
                        <center>
                            <span style={{ fontWeight: 'unset', fontSize: '14px' }}><b>Date of Placement</b></span><br />
                        </center>
                        <span >
                            <input
                                // style={{ height: "59px" }}
                                className={`${classes2['input_box']} origin`}
                                type="date"
                                defaultValue={dateofplacement}
                                // defaultValue={editableDetails.placement_date ? editableDetails.placement_date : ''}
                                min={todaydate}
                                onInput={e => handleChange(e.target.value, "placement_date")}></input>

                        </span>
                    </div>
                </div>
            </div>
            <div style={{ justifyContent: 'center', padding: '2%' }} className="row">
                <button id='submit_edited_indents' className="btn btn-success" onClick={e => submitHandler(e)}>Submit</button>
            </div>
        </div>
    )
}

export default EditIndents
